import React from 'react';
import { Picker } from 'antd-mobile';
import { Register } from '../factory';
import { queryCountrycodeList } from '../../../service/api';

interface IState {
    list: { label: string; value: string }[];
    internationalNumber: string;
    phoneNum: string;
    placeholderText: string
}
@Register({ name: 'dy-international-number' })
export default class DyInternationalNumber extends React.PureComponent<Props, IState> {
    phone = '';
    init = false;
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            internationalNumber: '',
            phoneNum: '',
            placeholderText:'请输入9位或10位手机号，可加0'
        };
    }

    componentDidMount() {
        this.getCountryCodeList();
    }

    UNSAFE_componentWillUpdate(nextProps: Readonly<Props>, nextState: Readonly<IState>) {
        const { value } = nextProps;
        const { list } = nextState;
        if (value && !this.init && list?.length) {
            this.init = true;
            const valueStr = value + '';
            const valueStrOne = valueStr.substring(0, 1);
            const valueStrTwo = valueStr.substring(0, 2);
            const valueStrThree = valueStr.substring(0, 3);
            const internationalNumber =
                list.find(item => {
                    return item.value === valueStrOne || item.value === valueStrTwo || item.value === valueStrThree;
                })?.value || '';
            const reg = new RegExp(`${internationalNumber}`);
            const defaultValue = valueStr.replace(reg, '');
            this.phone = defaultValue;
            this.setState({ internationalNumber, phoneNum: defaultValue });
        }
    }

    getCountryCodeList = async () => {
        const { result } = await queryCountrycodeList({
            hasMainland: true,
            stamp: new Date().getTime(),
        });
        let newList = [{label: "澳大利亚",value: "61"},{label: "英国",value: "44"},{label: "美国",value: "1"},{label: "加拿大",value: "1"}];
        result.map(item => {
           if(!['澳大利亚','英国','美国','加拿大','中国大陆'].includes(item.country_name)){
            newList.push({ label: item.country_name, value: item.country_code })
           }
        });
        this.setState({
            list: newList,
            internationalNumber: '61',
        });
    };

    handleChange = (internationalNumber: string) => {
        this.init = true;
        this.setState({ internationalNumber: internationalNumber[0] });
        this.props.onChange(`${internationalNumber}${this.phone}`);
        switch(internationalNumber[0]){
            case '61':
            this.setState({
                placeholderText:'请输入9位或10位手机号，可加0'
            });
            break;
            case '44':
            this.setState({
                placeholderText:'请输入10位或11位手机号，可加0'
            });
            break;
            case '1':
            this.setState({
                placeholderText:'请输入10位数的手机号'
            });
            break;
            default:
            this.setState({
                placeholderText:'请输入手机号'
            });
            break;
        }
    };

    handleInput = (ev: any) => {
        this.init = true;
        const { value } = ev.target;
        const { internationalNumber } = this.state;
        this.phone = value + '';
        // 大陆号码限制长度
        if (this.phone.length >= 11 && internationalNumber === '86') {
            this.phone = this.phone.substring(0, 11);
        }
        // 非大陆号码限制长度
        if (this.phone.length >= 20 && internationalNumber !== '86') {
            this.phone = this.phone.substring(0, 20);
        }
        switch(internationalNumber){
            case '61':
                this.phone = this.phone.substring(0, 10);
            break;
            case '44':
                this.phone = this.phone.substring(0, 11);
            break;
            case '1':
                this.phone = this.phone.substring(0, 10);
            break;
            default:
                this.phone = this.phone.substring(0, 20);
            break;
        }

        this.setState({ phoneNum: this.phone });
        this.props.onChange(`${internationalNumber}${this.phone}`);
    };

    render() {
        const { list, internationalNumber, phoneNum, placeholderText } = this.state;
        return (
            <div className="dy-international-number">
                <Picker data={list} cols={1} onOk={this.handleChange}>
                    <div className="dy-international-number-picker">+{internationalNumber || '请选择国际号'}</div>
                </Picker>
                <input
                    type="number"
                    className="dy-international-number-input"
                    value={phoneNum}
                    placeholder={placeholderText}
                    onChange={this.handleInput}
                />
            </div>
        );
    }
}
